import { Listing } from "../../types/Listing";
import { Profile } from "../../types/Profile";

enum AnalyticsSessionReferrerType {
    None,
    URL,
    Google,
    Bing,
    Facebook,
    EmailCampaign,
}

enum AnalyticsEventType {
    PageView,
    ContactFormSubmit,
    ListingVideoViewed,
    CallAgentClicked,
}

enum AnalyticsEventObjectType {
    Listing = 'Listing',
    Buy = 'Buy',
    Sold = 'Sold',
    Rent = 'Rent',
    Blog = 'Blog',
    BlogPost = 'BlogPost',
    About = 'About',
    Profile = 'Profile',
    Testimonials = 'Testimonials',
    Contact = 'Contact',
    Static = 'Static'
}

enum AnalyticsEventPriority {
    Normal,
    Realtime
}

class AnalyticsEventObject {
    Type: AnalyticsEventObjectType;
    Id: string;
    Descriptor: string;

    constructor(type: AnalyticsEventObjectType, id: string, descriptor?: string) {
        this.Type = type;
        this.Id = id;
        this.Descriptor = descriptor || '';
    }

    public static FromListing(listing: Listing): AnalyticsEventObject {
        return new AnalyticsEventObject(AnalyticsEventObjectType.Listing, listing.Id, listing.Address.FullAddress);
    }

    public static FromProfile(profile: Profile): AnalyticsEventObject {
        return new AnalyticsEventObject(AnalyticsEventObjectType.Profile, profile.Id, profile.FullName);
    }
}

class AnalyticsEvent {

    Type: AnalyticsEventType;
    Timestamp: Date;
    Priority: AnalyticsEventPriority;

    Object?: AnalyticsEventObject;
    
    constructor(type: AnalyticsEventType, object?: AnalyticsEventObject, priority?: AnalyticsEventPriority) {
        this.Type = type;
        this.Timestamp = new Date();
        this.Priority = priority ?? AnalyticsEventPriority.Normal;
        this.Object = object;
    }
}

class AnalyticsPageView extends AnalyticsEvent {
    Page: string;
    Title: string;

    constructor(page: string, title: string, object?: AnalyticsEventObject) {
        super(AnalyticsEventType.PageView, object);

        this.Page = page;
        this.Title = title;
    }
}

export { AnalyticsEvent, AnalyticsPageView, AnalyticsEventObject, AnalyticsEventObjectType, AnalyticsEventType, AnalyticsEventPriority, AnalyticsSessionReferrerType };
